"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _warehouse = require("@/api/warehouse");
var _utils = require("@/utils");
var _date = require("@/utils/date");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "AppMain",
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    }
  },
  data: function data() {
    return {
      totalExpiredProducts: 0,
      countNotFindRowWarning: 0
    };
  },
  created: function created() {
    this.fetchReport();
  },
  methods: {
    fetchReport: function fetchReport() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _warehouse.warehouseApi.findAllExpired();
            case 2:
              res = _context.sent;
              _this.totalExpiredProducts = res.data.filter(function (e) {
                return (0, _date.diffDayFromToday)(e.expired) >= 0;
              }).length;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleToListExpired: function handleToListExpired() {
      var routeData = this.$router.resolve({
        path: "/warehouse/index",
        query: {
          type: "expired"
        }
      });
      window.open(routeData.href, "_self");
      this.countNotFindRowWarning = 0;
      this.autoScrollToRow();
    },
    // function tự động scroll xuống hàng warning
    autoScrollToRow: function autoScrollToRow() {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var expiredId, listTableEmpty, listLoading, listRowWarning;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // check có tìm thấy tab 'expired'
              expiredId = document.getElementById("pane-expired");
              console.log("expiredId:", expiredId);
              if (expiredId) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return (0, _utils.sleep)(300);
            case 5:
              _this2.autoScrollToRow();
              return _context2.abrupt("return");
            case 7:
              // danh sách div dữ liệu có rỗng
              listTableEmpty = expiredId.getElementsByClassName("el-table__empty-text"); // danh sách div loading
              listLoading = expiredId.getElementsByClassName("el-loading-mask"); // check nếu số lượng gọi đệ quy lớn hơn 50 hoặc check mảng dữ liệu rỗng và div loading đã ẩn thì ko hoạt động tiếp theo
              if (!(_this2.countNotFindRowWarning >= 50 || listTableEmpty.length && listLoading.length && listLoading[0].getAttribute("style").includes("display: none;"))) {
                _context2.next = 11;
                break;
              }
              return _context2.abrupt("return");
            case 11:
              // danh sách div warning
              listRowWarning = expiredId.getElementsByClassName("row-warning"); // nếu ko có mảng warning thì gọi lại function
              if (listRowWarning.length) {
                _context2.next = 18;
                break;
              }
              _context2.next = 15;
              return (0, _utils.sleep)(300);
            case 15:
              _this2.countNotFindRowWarning++;
              _this2.autoScrollToRow();
              return _context2.abrupt("return");
            case 18:
              expiredId.getElementsByClassName("row-warning")[0].scrollIntoView({
                behavior: "smooth"
              });
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};